export default "__VITE_ASSET__N22VOI76__"